export default __webpack_public_path__ + "static/media/1431.bb26b2c2.png";